import { render, staticRenderFns } from "./TempUpload.vue?vue&type=template&id=5d1f25d8&scoped=true&"
import script from "./TempUpload.vue?vue&type=script&lang=js&"
export * from "./TempUpload.vue?vue&type=script&lang=js&"
import style0 from "./TempUpload.vue?vue&type=style&index=0&id=5d1f25d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1f25d8",
  null
  
)

export default component.exports